module.exports = "\r\n    <router-outlet></router-outlet>\r\n\r\n    <ngx-loading-bar></ngx-loading-bar>\r\n\r\n"